import { ISTLDefaultDataSource } from '@xeokit/xeokit-sdk';
import { STLDefaultDataSource } from '@xeokit/xeokit-sdk/src/plugins/STLLoaderPlugin/STLDefaultDataSource.js';

export class DataSourceSTL extends STLDefaultDataSource implements ISTLDefaultDataSource {
  cacheBuster: boolean = false;

  constructor(cfg: any = {}) {
    super(cfg);
    this.cacheBuster = cfg.cacheBuster !== false;
  }

  _cacheBusterURL(url: string) {
    if (!this.cacheBuster) {
      return url;
    }
    const timestamp = new Date().getTime();
    if (url.indexOf('?') > -1) {
      return url + '&_=' + timestamp;
    } else {
      return url + '?_=' + timestamp;
    }
  }

  // Gets the contents of the given .XKT file in an arraybuffer
  getSTL(src: string | number, ok: (buffer: ArrayBuffer) => void, error: (e: Error) => void) {
    src = this._cacheBusterURL(src as string);

    const processesStore = useProcessesStore();
    const config = useRuntimeConfig();

    const defaultCallback = () => {};
    ok = ok || defaultCallback;
    error = error || defaultCallback;

    const request = new CachedXHR(config.public.URL_EXP_TIME * 1000);
    request.overrideMimeType('application/json');
    request.open('GET', src as string, true);

    request.onprogress = function (event: ProgressEvent) {
      if (event.lengthComputable) {
        processesStore.updateDownloadProgress(src as string, event.loaded, event.total);
      }
    };

    request.onabort = function (event: ProgressEvent) {
      const error = new Error('Download aborted');
      processesStore.updateDownloadProgress(src as string, event.loaded, event.total, error);
    };

    request.ontimeout = function (event: ProgressEvent) {
      const error = new Error('Download timeout');
      processesStore.updateDownloadProgress(src as string, event.loaded, event.total, error);
    };

    request.onreadystatechange = function () {
      if (request.readyState === 4) {
        if (request.status !== 200) {
          error(new Error(request.statusText));
        }
      }
    };

    request.addEventListener('finish', async (event: Event) => {
      const blob = (event as CustomEvent).detail as Blob;
      ok(await blob.arrayBuffer());
    });

    request.send(null);
  }
}
